module.exports = "/images/documents-hub-icon.svg?4d8fb8876ad40961b43a24d549fa0bf8";